// extracted by mini-css-extract-plugin
module.exports = {"container":"xuAYgotHyIDdpY1haI1ec"};